import { useAuthStore } from '@munawb/hooks';
import type { ProfileWithDept } from '@munawb/types';

/**
 * يقرأ الـ profile من Zustand store أولاً، وإن كان فارغاً يرجع لـ localStorage.
 * مطلوب لأن beforeLoad يشتغل قبل أن يتهيأ الـ store عند إعادة تحميل الصفحة.
 */
export function getProfileSync(): ProfileWithDept | null {
  const { profile } = useAuthStore.getState();
  if (profile) return profile;

  try {
    const stored = localStorage.getItem('munawb-profile');
    if (!stored) return null;
    const parsed = JSON.parse(stored) as ProfileWithDept;
    // حدّث الـ store حتى لا نحتاج localStorage مرة أخرى في نفس الجلسة
    useAuthStore.getState().setProfile(parsed);
    return parsed;
  } catch {
    return null;
  }
}
